<template>
  <div>
    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          v-bind="attrs"
          v-on="on"
          outlined
          x-small
          fab
          dark
          class="warning"
          @click="linkGroupAndProjets(groupe)"
        >
          <v-icon>link</v-icon>
        </v-btn>
      </template>
      <span>Lier le groupe à des projets</span>
    </v-tooltip>

    <v-dialog v-model="dialog" persistent max-width="500px">
      <v-card>
        <v-card-text class="pa-4">
          <v-card-title> Groupe : {{ groupe.nom_groupe }} </v-card-title>
          <v-container grid-list-xs>
            <v-row>
              <v-col>
                <v-form ref="ProjetsDeAnimateur">
                  <v-select
                    multiple
                    ref="listeProjetsDeAnimateur"
                    :items="listeProjetsDeAnimateur"
                    v-model="groupe.projets"
                    label="Projets"
                    item-text="ll_programme"
                    item-value="id"
                    return-object
                  ></v-select>
                </v-form>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn rounded color="warning" @click="dialog = false">Annuler</v-btn>
          <v-btn rounded color="success" @click="savelinked()"
            >Sauvegarder</v-btn
          >
        </v-card-actions></v-card
      >
    </v-dialog>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
export default {
  data() {
    return {
      dialog: false,
      listeProjetsDeAnimateur: [],
    };
  },
  props: {
    groupe: {
      required: true,
    },
  },
  methods: {
    savelinked() {
      let self = this;
      self.$vloading.show();
      var groupeRef = this.$firebase
        .firestore()
        .collection("groupes")
        .doc(this.groupe.id);

      let listArray = [];
      this.groupe.projets.forEach(function (projet, index) {
        listArray[index] = projet.id_programme;
        listArray[index] = projet.id;
      });
      console.log("projets", this.groupe.projets);
      console.log("listArray", listArray);

      groupeRef
        .set(
          {
            projets: this.groupe.projets,
            projectList: listArray,
          },
          { merge: true }
        )
        .then(() => {
          console.log("Groupe successfully updated!");
          self.injectProjetToMenagesAndMembres(this.groupe, listArray);
          self.$vloading.hide();
          self.$emit("reloadAfficher");
        })
        .catch((error) => {
          console.error("Error writing document: ", error);
        });

      this.closeDialog();
    },

    injectProjetToMenagesAndMembres(groupe, listArray) {
      var self = this;
      var objet = {
        projets: groupe.projets,
        projectList: listArray,
      };

      //get menages du groupe
      const menages = self.$firebase.firestore().collection("newMenages");
      menages
        .where("id_groupe", "==", groupe.id)
        .get()
        .then((snapshots) => {
          if (snapshots.size > 0) {
            snapshots.forEach((snap) => {
              menages.doc(snap.id).set(objet, { merge: true });
              console.log("menage successfully updated!");
            });
          } else {
            console.log("no snap menages");
          }
        });

      //get membres du groupe
      const membres = self.$firebase.firestore().collection("membres");
      membres
        .where("id_groupe", "==", groupe.id)
        .get()
        .then((snapshots) => {
          if (snapshots.size > 0) {
            snapshots.forEach((snap) => {
              membres.doc(snap.id).set(objet, { merge: true });
              console.log("membre successfully updated!");
            });
          } else {
            console.log("no snap membres");
          }
        });
    },

    linkGroupAndProjets(groupe) {
      let self = this;
      var docRef = this.$firebase
        .firestore()
        .collection("users")
        .doc(groupe.responsable);
      docRef
        .get()
        .then((doc) => {
          if (doc.exists) {
            var projetAnimateurs = doc.data().projets;
            var resultUnion = _.union(
              self.groupe.projets,
              projetAnimateurs,
              "id_programme"
            );
            console.log(resultUnion);

            self.listeProjetsDeAnimateur = resultUnion;
          } else {
            // doc.data() will be undefined in this case
            console.log("No such document!");
          }
        })
        .catch((error) => {
          console.log("Error getting document:", error);
        });

      this.dialog = true;
    },
    closeDialog() {
      this.dialog = false;
      this.$refs.ProjetsDeAnimateur.reset();
    },
    ...mapActions({
      getAnimateurs: "Users/getAnimateurs",
      //GetGroupesDeRegions: "Groupes/GetGroupesDeRegions",
    }),
  },
  computed: {
    ...mapState({
      superviseurs: (state) =>
        _.filter(state.Users.identifiants, { role: "superviseur", active: 1 }),
    }),
    regionSupervisees: (state) => state.Utils.listeRegionsSupervisees,
  },
};
</script>

<style lang="scss" scoped></style>
